<script setup>
defineProps({ disabled: Boolean, showPulse: Boolean, pulseCount: { type: Number, default: 1 }, tooltip: String })
const emit = defineEmits(['search', 'pulse-end'])
</script>
<template>
  <q-btn
    icon="mdi-cloud-search"
    flat
    size="xs"
    round
    class="infobike-btn"
    :class="{ 'infobike-btn--pulse': showPulse }"
    :style="{ '--pulse-count': pulseCount }"
    :disable="disabled"
    @click="emit('search')"
    @animationend="emit('pulse-end')"
  >
    <q-tooltip>{{ tooltip }}</q-tooltip>
  </q-btn>
</template>
<style scoped>
.infobike-btn--pulse { animation: infobike-pulse 0.6s ease-out; animation-iteration-count: var(--pulse-count, 1); }
@keyframes infobike-pulse {
  0% { box-shadow: 0 0 0 0 rgba(var(--q-primary-rgb, 25, 118, 210), 0.6); }
  70% { box-shadow: 0 0 0 10px rgba(var(--q-primary-rgb, 25, 118, 210), 0); }
  100% { box-shadow: 0 0 0 0 rgba(var(--q-primary-rgb, 25, 118, 210), 0); }
}
</style>
